import { useQuery } from "react-query";
import { getUserAsset } from "services/apis";

/**
 * @typedef {import("services/apis").MallAsset} MallAsset
 */

/**
 * @typedef {import("react-query").UseQueryOptions<
 *   import("axios").AxiosResponse<{success: boolean, message: string, data: MallAsset}>,
 *   unknown,
 *   MallAsset,
 *   string[]
 * >} UseUserAssetOptions
 */

/**
 * 보유/사용 가능 자산 조회 공통 훅.
 *
 * `options`는 react-query `useQuery` 옵션이며, `select`를 넘기면 기본
 * `MallAsset` 반환값을 화면별 shape로 가공할 수 있습니다.
 *
 * @param {UseUserAssetOptions} [options]
 * @returns {import("react-query").UseQueryResult<MallAsset, unknown>}
 */
const useUserAsset = (options) => {
  return useQuery({
    queryKey: ["userAsset"],
    queryFn: getUserAsset,
    select: (data) => data.data.data,
    ...options,
  });
};

export default useUserAsset;
